import { Modal } from 'antd';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import LinkButton from '../../../common/LinkButton';
import CashflowSimulatorCalculator from '../components/CashflowSimulator/components/CashflowCalculator';
import CashflowSimulatorGraph from '../components/CashflowSimulator/components/CashflowGraph';
import { Deals } from '../redux/types';

type Props = {
    deal?: Deals;
};

const CashflowSimulatorModal: React.FC<Props> = ({ deal }) => {
    let uuid = useParams().uuid;

    const [open, setOpen] = useState(false);

    const onClickClose = () => {
        setOpen(false);
    };

    const onOpen = () => {
        setOpen(!open);
    };

    return (
        <div>
            <LinkButton title={'Try Now'} isArrow onClick={onOpen} />
            <Modal centered open={open} onCancel={onClickClose} footer={null} className="cashflow" width={'90%'}>
                <div className="flex flex-wrap h-auto">
                    <CashflowSimulatorCalculator
                        dealName={deal?.deal.info.summary?.title}
                        dealUUID={uuid}
                        cashflowSimulator={deal?.deal.cashFlowSimulator}
                        open={open}
                    />
                    <CashflowSimulatorGraph
                        dealName={deal?.deal.info.summary?.title}
                        currency={deal?.deal.cashFlowSimulator?.currency}
                    />
                </div>
            </Modal>
        </div>
    );
};

export default CashflowSimulatorModal;
